import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref } from "vue";
import _imports_0 from '@/assets/empty.svg';
var _hoisted_1 = {
  class: "group-study"
};
var _hoisted_2 = {
  key: 0,
  class: "group-study-div"
};
var _hoisted_3 = {
  class: "left-div"
};
var _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "empty-img"
};
var _hoisted_5 = {
  class: "left-item"
};
var _hoisted_6 = {
  class: "name-div"
};
var _hoisted_7 = {
  class: "left-name"
};
var _hoisted_8 = {
  class: "order-div"
};
var _hoisted_9 = {
  key: 0,
  class: "margin-8px"
};
var _hoisted_10 = {
  key: 1,
  class: "name-input"
};
var _hoisted_11 = ["onClick"];
var _hoisted_12 = {
  class: "grouped-div"
};
var _hoisted_13 = ["onClick"];
var _hoisted_14 = {
  key: 2
};
var _hoisted_15 = {
  key: 1,
  class: "right-div"
};
var _hoisted_16 = {
  key: 0,
  class: "ungrouped-div"
};
var _hoisted_17 = {
  class: "item-name"
};
var _hoisted_18 = {
  key: 1,
  class: "base-img"
};
var _hoisted_19 = ["src"];
import { ref } from 'vue';
/** 插件 */
import draggable from 'vuedraggable';
import topSearch from './compont/topSearch.vue';
import deleteDialog from './dialogs/deleteDialog.vue';
/** ui组件库 */
import { MessagePlugin as message } from 'tdesign-vue-next';
/** 工具 */
import { validateGroupName } from '@/util/validate.js';
/** 接口 */
import { getNoTeamStudentList, getTeamStudentLists, updGroup, updGroupSort, addStudent, delStudent, setHeadman, setSubjectMonitor, cancelSubjectMonitor } from '@/api/index-fu.js';
/** 初始化相关 */

export default {
  __name: 'Study',
  setup: function setup(__props) {
    var showBtn = ref(false); // 创建小组按钮显隐
    var searchForm = ref({}); // 查询参数

    var ungroupedList = ref([]); // 未分组
    var groupedList = ref([]); // 已创建小组
    var deleteVisible = ref(false); // 删除小组弹窗显隐
    var teamId = ref(null); // 小组id
    var copyName = ref('');
    var isLoading = ref(true);

    /**
     * 初始化相关方法
     */
    var getUngroupedList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var parmas, res, _res$data, code, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              parmas = {
                classId: searchForm.value.classId,
                classType: searchForm.value.classType
              };
              if (parmas.classType === 1) parmas.subjectDictItemCode = searchForm.value.subjectDictItemCode;
              _context.p = 1;
              _context.n = 2;
              return getNoTeamStudentList(parmas);
            case 2:
              res = _context.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === 0) {
                ungroupedList.value = data || [];
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              isLoading.value = false;
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function getUngroupedList() {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * 获取已创建小组列表
     */
    var getGroupedList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _res$data2, code, data, tempList, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return getTeamStudentLists(searchForm.value);
            case 1:
              res = _context2.v;
              _res$data2 = res.data, code = _res$data2.code, data = _res$data2.data;
              if (code === 0) {
                tempList = data || [];
                groupedList.value = tempList.map(function (i, j) {
                  i.isEdit = false; // 是否编辑状态
                  i.order = j + 1; // 排序
                  var teamStudents = i.teamStudents || [];
                  i.teamStudents = teamStudents.map(function (it) {
                    return _objectSpread(_objectSpread({}, it), {}, {
                      name: it.userName
                    });
                  });
                  return _objectSpread({}, i);
                });
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              isLoading.value = false;
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return function getGroupedList() {
        return _ref2.apply(this, arguments);
      };
    }();
    /**
     * 删除弹窗显隐改变
     */
    var changeDeleteVisible = function changeDeleteVisible(id) {
      teamId.value = id;
      deleteVisible.value = !deleteVisible.value;
    };

    //是否编辑小组名称
    var changeEditStatu = function changeEditStatu(bool, id, bool2) {
      var index = groupedList.value.findIndex(function (i) {
        return i.teamId === id;
      });
      if (bool) {
        copyName.value = groupedList.value[index].teamName;
      } else if (bool2) {
        groupedList.value[index].teamName = copyName.value;
      }
      groupedList.value[index].isEdit = bool;
    };

    /**
     * 编辑小组名称
     */
    var editGroupName = function editGroupName(id, name) {
      // 小组名称验证
      if (!name.length) {
        message.error('小组名称不能为空');
      } else if (name.length > 10) {
        message.error('限制10个字符内');
      } else if (!validateGroupName(name)) {
        message.error('只能输入汉字、数字、字母');
      } else {
        var data = Object.assign({}, searchForm.value, {
          id: id,
          teamName: name
        });
        updGroup(data).then(function (res) {
          if (res.data.code === 0) {
            changeEditStatu(false, id);
            message.success('编辑成功');
          }
        });
      }
    };

    /**
     * 小组顺序拖放改变
     */
    var changeGroupSort = function changeGroupSort() {
      var data = groupedList.value.map(function (i, index) {
        return {
          teamId: i.teamId,
          sort: index
        };
      });
      updGroupSort(data).then(function (res) {
        if (res.data.code === 0) {
          groupedList.value.forEach(function (i, index) {
            i.order = index + 1;
          });
          message.success('修改分组顺序成功');
        }
      });
    };

    /**
     * 分组小组成员改变
     */
    var changeGroupedStudent = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(st, el) {
        var data, _data, delResolve;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!st.added) {
                _context3.n = 1;
                break;
              }
              data = {
                // 添加
                userId: st.added.element.userId,
                teamId: el.teamId,
                deptId: searchForm.value.classId,
                userName: st.added.element.name,
                // headmanFlag: st.added.element.headmanFlag,
                headmanFlag: 0,
                oldTeamId: null,
                pinyinInitials: st.added.element.pinyinInitials
              };
              addStudent(data).then(function (res) {
                if (res.data.code === 0) {
                  // 移动小组后，去掉组长身份
                  groupedList.value[el.sort].teamStudents[st.added.newIndex].headmanFlag = 0;
                  message.success('添加成功');
                }
              });
              _context3.n = 3;
              break;
            case 1:
              if (!st.removed) {
                _context3.n = 3;
                break;
              }
              // 移除
              _data = {
                userId: st.removed.element.userId,
                teamId: el.teamId,
                deptId: searchForm.value.classId
              };
              _context3.n = 2;
              return delStudent(_data);
            case 2:
              delResolve = _context3.v;
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function changeGroupedStudent(_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    /**
     * 设置、取消小组组长 / 设置、取消学科班长
     */
    var changeGroupMonitor = function changeGroupMonitor(el) {
      if (Number(searchForm.value.subjectDictItemCode) === -1) {
        // 组长
        var data = {
          deptId: searchForm.value.classId,
          userId: el.userId,
          type: el.headmanFlag === 0 ? 1 : 0 // 0 取消小组长 1 设置小组长
        };
        groupedList.value.forEach(function (i) {
          i.teamStudents.forEach(function (it) {
            if (it.userId === el.userId) {
              data.teamId = i.teamId;
            }
          });
        });
        setHeadmanMtd(data);
      } else {
        // 班长
        var _data2 = {
          teamId: el.teamId,
          subjectDictItemCode: searchForm.value.subjectDictItemCode,
          subjectDictItemName: searchForm.value.subjectDictItemName,
          classId: searchForm.value.classId,
          userId: el.userId,
          name: el.name,
          classType: searchForm.value.classType
        };
        var findData = groupedList.value.find(function (i) {
          return i.teamId === el.teamId;
        });
        _data2.teamName = findData.teamName;
        if (el.isSubjectMonitor) cancelSubjectMonitorMtd(_data2); // 取消
        if (!el.isSubjectMonitor) setSubjectMonitorMtd(_data2); // 设置
      }
    };
    /** 事件相关方法 */
    /**
     * 设置小组组长
     */
    var setHeadmanMtd = function setHeadmanMtd(data) {
      setHeadman(data).then(function (res) {
        if (res.data.code === 0) {
          getGroupedList();
          message.success("".concat(data.type ? '设置' : '取消', "\u5C0F\u7EC4\u7EC4\u957F\u6210\u529F"));
        }
      });
    };
    /**
     * 设置学科班长
     */
    var setSubjectMonitorMtd = function setSubjectMonitorMtd(data) {
      setSubjectMonitor(data).then(function (res) {
        if (res.data.code === 0) {
          getGroupedList();
          message.success('设置学科班长成功');
        }
      });
    };
    /**
     * 取消学科班长
     */
    var cancelSubjectMonitorMtd = function cancelSubjectMonitorMtd(data) {
      cancelSubjectMonitor(data).then(function (res) {
        if (res.data.code === 0) {
          getGroupedList();
          message.success('取消学科班长成功');
        }
      });
    };
    /**
     * 查询
     */
    var searchData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(form) {
        var _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              console.log('134----接收到的form', form);
              isLoading.value = true;
              searchForm.value = form;
              _context4.p = 1;
              _context4.n = 2;
              return getUngroupedList();
            case 2:
              _context4.n = 3;
              return getGroupedList();
            case 3:
              // 获取班级分组信息
              console.log('searchData');
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t3 = _context4.v;
              console.log('error', _t3);
            case 5:
              _context4.p = 5;
              console.log('finally');
              isLoading.value = false;
              return _context4.f(5);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 4, 5, 6]]);
      }));
      return function searchData(_x3) {
        return _ref4.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_loading = _resolveComponent("loading");
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_button = _resolveComponent("t-button");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_popup = _resolveComponent("t-popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(topSearch, {
        modelValue: showBtn.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return showBtn.value = $event;
        }),
        onSearchData: searchData,
        class: "top-search"
      }, null, 8, ["modelValue"]), _withDirectives(_createVNode(_component_loading, {
        class: "loading"
      }, null, 512), [[_vShow, isLoading.value]]), !isLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [!groupedList.value.length ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : (_openBlock(), _createBlock(_unref(draggable), {
        key: 1,
        list: groupedList.value,
        group: {
          name: 'group'
        },
        disabled: !showBtn.value,
        onChange: changeGroupSort
      }, {
        item: _withCtx(function (_ref5) {
          var element = _ref5.element;
          return [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(element.order), 1), !element.isEdit ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(element.teamName), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_t_input, {
            modelValue: element.teamName,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return element.teamName = $event;
            },
            class: "input-margin"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_t_button, {
            theme: "default",
            class: "cancel-btn",
            onClick: function onClick($event) {
              return changeEditStatu(false, element.teamId, true);
            }
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[1] || (_cache[1] = [_createTextVNode("取消", -1)]));
            }),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_t_button, {
            theme: "primary",
            onClick: function onClick($event) {
              return editGroupName(element.teamId, element.teamName);
            }
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[2] || (_cache[2] = [_createTextVNode("确认", -1)]));
            }),
            _: 1
          }, 8, ["onClick"])])), !element.isEdit && showBtn.value ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            name: "edit",
            alt: "",
            class: "edit-icon",
            onClick: function onClick($event) {
              return changeEditStatu(true, element.teamId);
            }
          }, null, 8, ["onClick"])) : _createCommentVNode("", true)]), showBtn.value ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "right-delete",
            onClick: function onClick($event) {
              return changeDeleteVisible(element.teamId);
            }
          }, "删除", 8, _hoisted_11)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createVNode(_unref(draggable), {
            list: element.teamStudents,
            group: {
              name: 'list'
            },
            disabled: !showBtn.value,
            onChange: function onChange($event) {
              return changeGroupedStudent($event, element);
            },
            class: "drag-area"
          }, {
            item: _withCtx(function (_ref6) {
              var element = _ref6.element;
              return [_createElementVNode("div", {
                class: _normalizeClass(["item-name", {
                  'width-add': element.isSubjectMonitor === 1 && Number(searchForm.value.subjectDictItemCode) !== -1 || element.headmanFlag === 1
                }])
              }, [searchForm.value.classType === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_withDirectives(_createVNode(_component_svg_icon, {
                name: "classLeader",
                alt: "",
                class: "right-4px"
              }, null, 512), [[_vShow, element.isSubjectMonitor === 1 && Number(searchForm.value.subjectDictItemCode) !== -1]]), _withDirectives(_createVNode(_component_svg_icon, {
                name: "star",
                alt: "",
                class: "right-4px"
              }, null, 512), [[_vShow, element.headmanFlag === 1]])], 64)) : _createCommentVNode("", true), searchForm.value.classType === 0 ? (_openBlock(), _createBlock(_component_t_popup, {
                key: 1,
                placement: "bottom"
              }, {
                content: _withCtx(function () {
                  return [_createElementVNode("div", {
                    onClick: function onClick($event) {
                      return changeGroupMonitor(element);
                    }
                  }, _toDisplayString(Number(searchForm.value.subjectDictItemCode) === -1 ? element.headmanFlag ? '取消小组组长' : '设为小组组长' : element.isSubjectMonitor ? '取消学科班长' : '设为学科班长'), 9, _hoisted_13)];
                }),
                default: _withCtx(function () {
                  return [_createElementVNode("div", null, _toDisplayString(element.name), 1)];
                }),
                _: 2
              }, 1024)) : _createCommentVNode("", true), searchForm.value.classType === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(element.name), 1)) : _createCommentVNode("", true)], 2)];
            }),
            _: 2
          }, 1032, ["list", "disabled", "onChange"])])])];
        }),
        _: 1
      }, 8, ["list", "disabled"]))])])) : _createCommentVNode("", true), !isLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "title-div"
      }, "未分组", -1)), ungroupedList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_unref(draggable), {
        list: ungroupedList.value,
        group: {
          name: 'list'
        },
        class: "drag-ungrouped-area"
      }, {
        item: _withCtx(function (_ref7) {
          var element = _ref7.element;
          return [_createElementVNode("div", _hoisted_17, _toDisplayString(element.name), 1)];
        }),
        _: 1
      }, 8, ["list"])])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("img", {
        src: require('@/assets/empty.svg'),
        alt: ""
      }, null, 8, _hoisted_19)]))])) : _createCommentVNode("", true)]), _createVNode(deleteDialog, {
        "delete-visible": deleteVisible.value,
        "team-id": teamId.value,
        onCloseDeleteDialog: changeDeleteVisible,
        onRefreshGroupedList: getGroupedList
      }, null, 8, ["delete-visible", "team-id"])], 64);
    };
  }
};